import { render, staticRenderFns } from "./CalendarSettingsOverlay.vue?vue&type=template&id=31049e3a&scoped=true"
import script from "./CalendarSettingsOverlay.vue?vue&type=script&lang=js"
export * from "./CalendarSettingsOverlay.vue?vue&type=script&lang=js"
import style0 from "./CalendarSettingsOverlay.vue?vue&type=style&index=0&id=31049e3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31049e3a",
  null
  
)

export default component.exports